import { DeployReason, PartialRefreshTable } from "../../api/types"

export const PARTIAL: {
	table: PartialRefreshTable
	label: string
	note: string
}[] = [
	{
		table: PartialRefreshTable.OcProductDescription,
		label: "Наименования и описания",
		note: "пересобирает oc_product_description из ERP на всех языках сайта",
	},
	{
		table: PartialRefreshTable.OcProductWeight,
		label: "Вес и параметры товаров",
		note: "правит oc_product: вес, габариты, статусы",
	},
	{
		table: PartialRefreshTable.OcProductCategory,
		label: "Список категорий",
		note: "сверяет дерево категорий сайта с деревом ERP",
	},
	{
		table: PartialRefreshTable.OcProductCategoryImages,
		label: "Картинки разделов",
		note: "обновляет картинки категорий, схема — «Сайт Риги»",
	},
]

/** Почему группа не уедет на сайт — расшифровка `DeployReason`. */
export const REASONS: Record<DeployReason, string> = {
	[DeployReason.ShowStatus]: "вывод в каталоге сайта не прописан",
	[DeployReason.NameNotTranslated]: "наименование не переведено",
	[DeployReason.NoDescriptionTranslated]: "описание не переведено",
	[DeployReason.NotCheckedDescription]: "описание не проверено",
	[DeployReason.NotCheckedImage]: "изображения не проверены",
}

/** Время операции — миллисекунды до секунды, дальше секундами. */
export function duration(ms: number): string {
	return ms < 1000 ? `${ms} мс` : `${(ms / 1000).toFixed(1)} с`
}
